import {Capacitor,CapacitorHttp} from "@capacitor/core";

/** Native requests identify the app and do not depend on WebView CORS rules. */
export async function experienceRequest(url:string,signal:AbortSignal,init?:RequestInit):Promise<unknown>{
  if(signal.aborted)throw new Error("aborted");
  if(Capacitor.isNativePlatform()){
    // The native bridge does not observe AbortSignal. Bound the caller as well,
    // otherwise a 5-second search deadline still waits for the 15-second socket.
    let abort:(()=>void)|undefined;
    const cancelled=new Promise<never>((_,reject)=>{abort=()=>reject(new Error("aborted"));signal.addEventListener("abort",abort,{once:true});});
    let response;
    try {response=await Promise.race([CapacitorHttp.request({url,method:init?.method||"GET",headers:{Accept:"application/json","User-Agent":"Mundely/1.0 (travel planning; https://mundely.app)",...init?.headers as Record<string,string>},data:init?.body?.toString(),connectTimeout:8000,readTimeout:15000,responseType:"json"}),cancelled]);}
    finally{if(abort)signal.removeEventListener("abort",abort);}
    if(signal.aborted)throw new Error("aborted");
    if(response.status<200||response.status>=300)throw new Error(`experience-provider/${response.status}`);
    return typeof response.data==="string"?JSON.parse(response.data):response.data;
  }
  const controller=new AbortController(),abort=()=>controller.abort();
  signal.addEventListener("abort",abort,{once:true});
  const timer=setTimeout(abort,15000);
  try{const response=await fetch(url,{...init,signal:controller.signal,headers:{Accept:"application/json",...init?.headers}});if(!response.ok)throw new Error(`experience-provider/${response.status}`);return await response.json();}
  finally{clearTimeout(timer);signal.removeEventListener("abort",abort);}
}
